import React from "react";
import { Redirect } from "react-router-dom";

import queryString from "query-string";

import MainBodyTabs from "../common/MainBodyTabs";
import MainButton from "../common/MainButton";
import MainTitle from "../common/MainTitle";
import Routes from "./Routes";

import lbl from "../../data/Labels.json";

const TeacherProfile = (props) => {
  const { teacherName } = queryString.parse(props.location.search);
  const { tid, path } = props.match.params;
  const nameQuery = `teacherName=${teacherName || ""}`;

  // Legacy placeholder path from older builds.
  if (path === "234") {
    return <Redirect to={`/mis/teachers/${tid}/profile/info?${nameQuery}`} />;
  }

  const tabs = [
    {
      name: "اطلاعات عمومی",
      path: "info",
      urlParams: nameQuery,
    },
    {
      name: "معاشات",
      path: "salary",
      urlParams: nameQuery,
    },
    {
      name: lbl.DailyEarnings || "معاش امروز",
      path: "daily-salary",
      urlParams: nameQuery,
    },
    {
      name: "کتابخانه",
      path: "library",
      urlParams: nameQuery,
    },
    {
      name: "امتیازات",
      path: "benefit",
      urlParams: nameQuery,
    },
    {
      name: "قرارداد ها",
      path: "contracts",
      urlParams: nameQuery,
    },
  ];

  return (
    <div className="main-content">
      <div className="main-content-header">
        <div className="right-content">
          <MainButton title={lbl.PrevPage} type={"back"} />
          <MainTitle title={teacherName} />
        </div>
      </div>
      <div className="main-content-body">
        <MainBodyTabs tabs={tabs} {...props} />
        <Routes {...props} />
      </div>
    </div>
  );
};

export default TeacherProfile;
